import React, { Component } from 'react'
import { connect } from 'react-redux'
import { glasConfig } from '../constants/Config'
import * as TemplateActions from '../actions/TemplateActions'
import Snackbar from 'material-ui/Snackbar'

class SettingTemplate extends Component {
	constructor(props) {
		super(props)
		const templateTitle = this.props.templateTitle || ''
		this.state = {
			templateTitle: templateTitle,
			templateTitleLength: templateTitle.length,
			templateContent: this.props.templateContent || '',
			templateId: this.props.templateId || '',
			templateDisable: true,
			templateExist: false,
		}
	}

	componentDidMount() {
		// If editing, enable save button if both fields have value
		if (this.state.templateTitle && this.isContentValid(this.state.templateContent)) {
			this.setState({ templateDisable: false })
		}
	}

	// componentWillReceiveProps(nextProps) {
	// 	if (nextProps.Template && nextProps.Template.templateExist) {
	// 		this.setState({ templateExist: true })
	// 	}
	// }

	isContentValid(content) {
		return content && content.trim().length > 0
	}

	updateSaveButtonState(title, content) {
		const titleValid = title && title.length > 0
		const contentValid = this.isContentValid(content)
		this.setState({
			templateDisable: !(titleValid && contentValid),
		})
	}

	handleTitleChange(e) {
		const value = e.target.value.replace(/[\s\n\r]/g, '')
		const length = value.length

		if (length > glasConfig.template.title) {
			return
		}

		this.setState({
			templateTitle: value,
			templateTitleLength: length,
		}, () => {
			this.updateSaveButtonState(value, this.state.templateContent)
		})
	}

	handleTitleKeyDown(e) {
		if (e.key === ' ' || e.key === 'Enter') {
			e.preventDefault()
		}
	}

	handleContentChange(e) {
		const value = e.target.value
		this.setState({
			templateContent: value,
		}, () => {
			this.updateSaveButtonState(this.state.templateTitle, value)
		})
	}

	handleTemplateExistClose() {
		this.setState({ templateExist: false })
	}

	handleSubmit(e) {
		e.preventDefault()
		const { dispatch } = this.props
		let data = {}

		if (this.state.templateId) {
			data = {
				templateTitle: this.state.templateTitle,
				templateContent: this.state.templateContent,
				templateId: this.state.templateId,
				templateGet: true,
			}
			dispatch(TemplateActions.putTemplate(data)).then((result) => {
				if (result && result.success) {
					if (this.props.onSaveSuccess) {
						setTimeout(() => {
							this.props.onSaveSuccess()
						}, 500)
					}
				} else if (result && result.code === 52) {
					this.setState({ templateExist: true })
				}
			})
		} else {
			data = {
				templateTitle: this.state.templateTitle,
				templateContent: this.state.templateContent,
				templateGet: true,
			}
			dispatch(TemplateActions.postTemplate(data)).then((result) => {
				if (result && result.success) {
					if (this.props.onSaveSuccess) {
						setTimeout(() => {
							this.props.onSaveSuccess()
						}, 500)
					}
				} else if (result && result.code === 52) {
					this.setState({ templateExist: true })
				}
			})
		}
	}

	render() {
		const charCounter = `${this.state.templateTitleLength}/6文字`
		const isDisabled = this.state.templateDisable

		return (
			<div style={formStyles.wrapper}>
				<form onSubmit={(e) => this.handleSubmit(e)}>
					<div style={formStyles.fieldGroup}>
						<label style={formStyles.label}>タイトル</label>
						<div style={formStyles.inputWrapper}>
							<input
								type="text"
								name="templateTitle"
								placeholder="タイトルを入力してください"
								maxLength={glasConfig.template.title}
								value={this.state.templateTitle}
								onChange={(e) => this.handleTitleChange(e)}
								onKeyDown={(e) => this.handleTitleKeyDown(e)}
								style={formStyles.titleInput}
							/>
							<span style={formStyles.charCounter}>{charCounter}</span>
						</div>
					</div>

					<div style={formStyles.fieldGroup}>
						<label style={formStyles.label}>内容</label>
						<textarea
							name="templateContent"
							placeholder="テンプレート内容を入力してください"
							value={this.state.templateContent}
							onChange={(e) => this.handleContentChange(e)}
							style={formStyles.contentTextarea}
						/>
					</div>

					<div style={formStyles.btnWrapper}>
						<button
							type="submit"
							style={isDisabled ? formStyles.saveBtnDisabled : formStyles.saveBtnEnabled}
							disabled={isDisabled}
						>
							保存
						</button>
					</div>
				</form>

				<Snackbar
					open={this.state.templateExist}
					message="テンプレートのタイトルは既に存在します。"
					autoHideDuration={3000}
					onRequestClose={() => this.handleTemplateExistClose()}
				/>
			</div>
		)
	}
}

const formStyles = {
	wrapper: {
		padding: '24px',
		width: '440px',
	},
	fieldGroup: {
		marginBottom: '32px',
	},
	label: {
		display: 'block',
		fontSize: '15px',
		fontFamily: 'HiraginoKakuGothicPro-W6, sans-serif',
		color: 'rgba(0,0,0,0.87)',
		marginBottom: '14px',
	},
	inputWrapper: {
		position: 'relative',
	},
	titleInput: {
		width: '100%',
		height: '43px',
		border: '1px solid rgba(0,0,0,0.12)',
		borderRadius: '2px',
		padding: '0 90px 0 10px',
		fontSize: '15px',
		fontFamily: 'HiraginoKakuGothicPro-W3, sans-serif',
		color: 'rgba(0,0,0,0.87)',
		outline: 'none',
		boxSizing: 'border-box',
		lineHeight: '31px',
	},
	charCounter: {
		position: 'absolute',
		right: '10px',
		top: '50%',
		transform: 'translateY(-50%)',
		fontSize: '12px',
		fontFamily: 'HiraginoKakuGothicPro-W3, sans-serif',
		color: 'rgba(0,0,0,0.38)',
		lineHeight: '24px',
	},
	contentTextarea: {
		width: '100%',
		height: '403px',
		border: '1px solid rgba(0,0,0,0.12)',
		borderRadius: '2px',
		padding: '7px 10px',
		fontSize: '15px',
		fontFamily: 'HiraginoKakuGothicPro-W3, sans-serif',
		color: 'rgba(0,0,0,0.87)',
		outline: 'none',
		boxSizing: 'border-box',
		resize: 'none',
		lineHeight: '1.5',
	},
	btnWrapper: {
		marginTop: '24px',
	},
	saveBtnDisabled: {
		backgroundColor: '#e5e5e5',
		color: 'rgba(0,0,0,0.38)',
		border: 'none',
		borderRadius: '2px',
		padding: '6px 30px',
		fontSize: '15px',
		fontFamily: 'HiraginoKakuGothicPro-W3, sans-serif',
		cursor: 'not-allowed',
		height: '36px',
	},
	saveBtnEnabled: {
		backgroundColor: '#11ad9d',
		color: '#fff',
		border: 'none',
		borderRadius: '2px',
		padding: '6px 30px',
		fontSize: '15px',
		fontFamily: 'HiraginoKakuGothicPro-W6, sans-serif',
		cursor: 'pointer',
		boxShadow: '0 2px 2px rgba(0,0,0,0.24), 0 0 2px rgba(0,0,0,0.12)',
		height: '36px',
	},
}

const mapStateToProps = (store) => {
	return { Template: store.Template }
}

export default connect(mapStateToProps)(SettingTemplate)
